import React from 'react';
import Sidebar from 'react-sidebar';
import { SidebarContent } from '../../common/TagsSidebar/SidebarContent';

class TaggingComponent extends React.Component {
  constructor(props) {
    super(props);
    this.onTagsClick = this.onTagsClick.bind(this);
    this.closeSideBarFromInsideSideBar =
      this.closeSideBarFromInsideSideBar.bind(this);
    this.state = {
      noTagSelection: false,
      unTagSelected: true,
      clearSearchText: false,
      sidebarOpen: false,
    };
  }
  onTagsClick = () => {
    this.setState({ noTagSelection: true, sidebarOpen: true });
  };
  closeSideBarFromInsideSideBar = () => {
    this.setState({ sidebarOpen: false });
  };
  onTagInfoClick = () => {};
  deleteTag = (e) => {
    console.log(e);
  };
  doneTagging = (e) => {
    console.log(e);
  };
  handleAddTagButton(e) {
    console.log(e);
  }

  toggleCheckBox = () => {};
  onUnTagSelected = () => {};
  onRemeberThisInfoClick = () => {};
  render() {
    // let noTagSelection = true;
    // this.props.selectedTransactionsToTag.length > 0 ? noTagSelection = false : noTagSelection = true;
    return (
      <div>
        <div>
          <Sidebar
            sidebar={
              <SidebarContent
                untaggedObj={this.props.untaggedObj}
                noTagSelection={this.props.noTagSelection}
                customTags={this.props.customTags}
                categoryTags={this.props.categoryTags}
                content={this.props.content}
                assignTag={this.props.assignTag}
                closeButton={this.props.closeSideBar}
                onTagInfoClick={this.props.onTagInfoClick}
                deleteTag={this.props.deleteTag}
                rememberThisIconClickOpen={this.props.rememberThisIconClickOpen}
                toggleCheckBox={this.toggleCheckBox}
                onUnTagSelected={this.props.assignTag}
                unTagSelected={this.props.assignTag}
                doneTagging={this.doneTagging}
                handleAddTagButton={this.handleAddTagButton}
                nextAccountDetails={this.state.clearSearchText}
                cssActiveClassForSelectedTags={
                  this.props.cssActiveClassForSelectedTags
                }
                flagForEditTag={this.props.flagForEditTag}
                flagForEditTagFunc={this.props.flagForEditTagFunc}
              />
            }
            open={this.props.sidebarOpen}
            rootClassName="rootSideBar"
            sidebarClassName="SideBarBox"
            contentClassName="contentSideBar"
            overlayClassName="overlaySideBar"
            pullRight
            touch={false}
          />
        </div>
      </div>
    );
  }
}

export default TaggingComponent;
